import { inject } from '@angular/core';

import { AuthService } from '~/api/auth/auth.service';

import { UserRole } from '../types/user.role';

/**
 * Role guard for routes
 */
export const roleGuard = (roles: UserRole[]) => () =>
  inject(AuthService)
    .userRoles()
    .some((role) => roles.includes(role));
